
import React, { useEffect,  useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {  getSectionsClientByMilestone } from "../../store/actions/CreateCourse/CourseApi";
import { Blocks, ChevronDown, ChevronUp, Fan } from "lucide-react";
import PlayerPageSectionCard from "./PlayerPageSectionCard";

const PlayerPageCardSections =({courseId,playerCard1Object,setCurrentItem,milestoneId})=>{

    
        const [itemArr, setItemArr] = useState([]);
               const [counts, setCounts] = useState({});
               
                       const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
               
      const [sort, setSort] = useState("ASC");
               const [pageNo, setPageNo] = useState(1);
               const [limit, setLimit] = useState(10);
             const [dropDownVal, setDropDownVal] = useState("Active");
                const [startDate, setStartDate] = useState(null);
          
            const [endDate, setEndDate] = useState(null);
      const [advancedFilters , setAdvancedFilters] =useState(true)
         const [toggleStatePaid , setToggleStatePaid] =useState(null)
         const [toggleStateLifetime , setToggleStateLifetime] =useState(null)
       
       const dispatch = useDispatch();
                const user = useSelector((state)=>state?.user?.user);
                     
                const [snackbarVisible, setSnackbarVisible] = useState(false);
                                 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                                 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                           
                                  
                              const showSnackbar = () => {
                                setSnackbarVisible(true);
                              };
                             
                              const hideSnackbar = () => {
                                setSnackbarVisible(false);
                              };
                        
                        
                                   
                                   
                                
                               const [animate, setAnimate] = useState(false);
                 
                  const [loader , setLoader] =useState({status:true});
         
             
                    const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                    const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                   );
                   
                       const userData =useSelector((state)=>state?.user?.user);
                      const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                      const appId = useSelector((state)=>state?.user?.user?.appId);
                    
                              
           
         const fireGetSectionsClientByMilestone=()=>{
                setItemArr([])
                 
             
               setItemArrLoading([{},{},{},{}])
               setLoader({status:true});
                     const apiData = dispatch(getSectionsClientByMilestone({userEmail:userEmail?userEmail:"",
            currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,postParent:milestoneId}));
                     /* get response as Promise   */
                     apiData.then(response => {
                     console.log(response)
               
                       if(response?.sections){
                       setItemArr(response?.sections);
               setItemArrLoading([])
                       setResponseMessage(response?.message);
                       setSnackbarColor("rgba(144, 202, 249,1)");
                     
                   setLoader({status:false});
                   
                   // setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                   },1000)
                   
                         
                       
                      if(response?.logout){
                      
                       setResponseMessage("You are Logged Out!!!");
                         
                       setSnackbarColor("#958FDA");
                     
                       
                        
                   setLoader({status:false});
                   
                   setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                    
                      
                   },3000)
                       setTimeout(()=>{
                         dispatch({type:"LOGOUT"});
                   
                       },3000)
                       
                     }
                   
                       }else{
                         setResponseMessage("Something Went Wrong...");
                         
                         setSnackbarColor("#958FDA");
                       
                          
                     setLoader({status:false});
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)    }
                   
                     }).catch(error => {
                    
                       //popup of error Info
                       setResponseMessage("Something Went Wrong...");
                         
                       setSnackbarColor("#958FDA");
                    
                       
                        
                   setLoader({status:false});
                   
                   setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                    
                      
                   },3000)
                      
                     });
                }
       
     
     useEffect(()=>{fireGetSectionsClientByMilestone()},[])
       const flattenedData = itemArr!=[]?Object.values(itemArr):'';
     
              const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
      
    return(<> {flattenedDataLoading?.length==0?flattenedData?.length?
flattenedData?.map((item,index)=>(<div  key={index} >
<PlayerPageSectionCard courseId={courseId} playerCard1Object={playerCard1Object} setCurrentItem={(v)=>{setCurrentItem(v)}} contentItem={item} />
</div>)):"":""}
    </>)
}
export default PlayerPageCardSections